import { ENERGY_SOURCE_KEY } from "../bisko/energy-source-key";
export const HEATING_TYPE_LIST = [
    { key: "GAS_CONDENSING_BOILER", energySourceKey: ENERGY_SOURCE_KEY.NATURAL_GAS },
    { key: "OIL_CONDENSING_BOILER", energySourceKey: ENERGY_SOURCE_KEY.HEATING_OIL },
    { key: "DISTRICT_HEATING", energySourceKey: ENERGY_SOURCE_KEY.DISTRICT_HEATING },
    { key: "LOCAL_HEATING", energySourceKey: ENERGY_SOURCE_KEY.LOCAL_HEATING },
    { key: "LPG_BOILER", energySourceKey: ENERGY_SOURCE_KEY.LPG_STATIONARY },
    { key: "BIOMASS_BOILER", energySourceKey: ENERGY_SOURCE_KEY.BIOMASS },
    { key: "BIOGAS_BOILER", energySourceKey: ENERGY_SOURCE_KEY.BIOGAS },
    { key: "ELECTRIC_HEATING", energySourceKey: ENERGY_SOURCE_KEY.ELECTRICITY_FOR_HEATING },
    { key: "HEAT_PUMP", energySourceKey: ENERGY_SOURCE_KEY.ENVIRONMENTAL_HEAT },
];
export const HEATING_TYPE_KEY_LIST = HEATING_TYPE_LIST.map((type) => type.key);
export const ENERGY_SOURCE_KEY_BY_HEATING_TYPE = Object.fromEntries(HEATING_TYPE_LIST.map((type) => [type.key, type.energySourceKey]));
export const isHeatingTypeKey = (value) => typeof value === "string" && HEATING_TYPE_KEY_LIST.includes(value);
